import script from "./Xieyi.vue?vue&type=script&setup=true&lang=js"
export * from "./Xieyi.vue?vue&type=script&setup=true&lang=js"

import "./Xieyi.vue?vue&type=style&index=0&id=190fd88e&lang=css"

const __exports__ = script;

export default __exports__